import { render } from "./TheFooterForm.vue?vue&type=template&id=419fe898&scoped=true"
const script = {}

import "./TheFooterForm.vue?vue&type=style&index=0&id=419fe898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419fe898"]])

export default __exports__